module.exports = __webpack_public_path__ + "media/images/technical-support-c0432b049b66f90433f4205607ccbbc0.png";